<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('skip-milestones') && data.skipped_at !== null" class="fa fa-step-backward fa-lg pointer"
           @click="undoSkip" :title="uLang('app.start_skipped_milestone')"></i>
        <i v-if="this.$can('skip-milestones') && data.skipped_at === null" class="fa fa-step-forward fa-lg pointer"
           @click="skip" :title="uLang('app.skip_milestone')"></i>
    </div>
</template>

<script>
    import {SuccessAlert, ConfirmationAlert, ErrorAlert} from '~/Swals';

    export default {
        name: 'actions',
        props: ['data', 'index'],

        methods: {
            skip() {
                new ConfirmationAlert({text: this.uLang('app.skip_milestone_question')})
                    .show()
                    .then(async () => {
                        this.commitSkip()
                    });
            },

            undoSkip() {
                new ConfirmationAlert({text: this.uLang('app.undo_skip_milestone_question')})
                    .show()
                    .then(async () => {
                        this.commitUndoSkip()
                    });
            },

            async commitSkip() {
                window.axios.put(
                    route('relations.trajectory-enrolments.milestone-progresses.skip', {
                        milestone_progress: this.data.id,
                    }),
                    {}
                ).then(() => {
                    new SuccessAlert({
                        title: uLang('app.milestone_progress'),
                        text: this.uLang('app.milestone_progress_skipped')
                    }).show();
                    vue.$emit('reloadTable');
                }).catch(({response}) => {
                    this.handleError(response);
                })
            },

            async commitUndoSkip() {
                window.axios.put(
                    route('relations.trajectory-enrolments.milestone-progresses.undo_skip', {
                        milestone_progress: this.data.id,
                    }),
                    {}
                ).then(() => {
                    new SuccessAlert({
                        title: uLang('app.milestone_progress'),
                        text: this.uLang('app.milestone_progress_unskipped')
                    }).show();
                    vue.$emit('reloadTable');
                }).catch(({response}) => {
                    this.handleError(response)
                })
            },

            handleError(response) {
                if (response.status === 403) {
                    response.data.message = 'U heeft geen rechten voor deze actie op dit traject.';
                }
                
                new ErrorAlert({
                    text: response.data.message
                }).show();
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>